import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-primary text-white" }
const _hoisted_5 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-backdrop fade show",
  id: "backdrop",
  style: {"display":"none"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "theModal",
      class: "modal fade",
      id: _ctx.idKey + 'Modal',
      tabindex: "-1",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
            _createElementVNode("button", {
              ref: "closeButton",
              type: "button",
              class: "btn-close btn-close-white",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
              "aria-label": "Close"
            }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ], 8, _hoisted_1),
    _hoisted_7
  ], 64))
}